import moment from 'moment-timezone';
export const dateHumanReadable = value => {
  return moment
    .utc(value)
    .local()
    .fromNow();
};
